import axios from "axios";

import { getCustomerSignedToken, logoutCustomer } from "../data/customerTokens";
import { isMobile } from "../lib/isMobile";
import Logger from "../services/Logger";

const sharedConfig = require("../config/sharedConfig");

export async function cbtResponse(response) {
  try {
    const resp = await response;
    const { status, data } = resp;

    if (status >= 200 && status < 300) {
      return { success: true, data };
    }
    if (data.error) {
      cbtError(data.error);
    }

    return { success: false, errorMsg: data, errorCode: status };
  } catch (e) {
    cbtError(e);
    return { success: false, errorMsg: e, errorCode: e.response?.status };
  }
}

function cbtError(e) {
  Logger.error("CBT communication error: ", e);

  if (!isMobile()) {
    if (!window.errorDisplayed) {
      alert(
        `We have some problem with CBT communication and you were logged off. Please log in again. If the problem persists please contact our support. Thank you.`
      );
      window.errorDisplayed = true;
    }
    window.location = "/";
  } else {
    alert(
      `We have some problem with CBT mobile communication and you were logged off. Please log in again. If the problem persists please contact our support. Thank you.`
    );
  }

  logoutCustomer();
}

export default async function getCbtClient({
  cbtToken,
  customerUsername,
  cbtApiUrl,
}) {
  const customerSignedToken = await getCustomerSignedToken();
  const cbtApiUrlEnv =
    process.env.NEXT_PUBLIC_D4_cbtApiUrl ||
    (typeof window !== "undefined" && window?.__ENV?.NEXT_PUBLIC_D4_cbtApiUrl);

  return axios.create({
    baseURL: cbtApiUrl || cbtApiUrlEnv || sharedConfig.cbtApiUrl,
    params: customerUsername && {
      email: customerUsername.includes("---")
        ? customerUsername.split("---")[2]
        : customerUsername,
    },
    headers: {
      "x-api-key": cbtToken,
      Authorization: customerSignedToken,
    },
    validateStatus: (status) => {
      return (status >= 200 && status < 300) || status === 409;
    },
  });
}
